import { ACTION_TYPES } from "./config";
import { Path } from "./utilities";

var initialState = {};

export function reducer(state = initialState, action) {
  var { type, payload } = action;

  switch (type) {
    case ACTION_TYPES.set: {
      return {
        // since we don't need to store multiple entries, just overwrite the state
        [Path.markRecovered(Path.create())]: payload.data,
      };
    }
    case ACTION_TYPES.reset: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
